import { MessageSquare } from 'lucide-react';
import { palette, fontFamily } from '../../../styles/tokens';

export function EmptyThread() {
  return (
    <div style={{
      flex: 1, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: palette.bg,
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: 20,
        background: palette.g100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 16,
      }}>
        <MessageSquare size={28} color={palette.g300} strokeWidth={1.5} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 500, color: palette.g500, fontFamily }}>
        Select a conversation
      </div>
      <div style={{ fontSize: 13, color: palette.g400, marginTop: 4, fontFamily, maxWidth: 260, textAlign: 'center', lineHeight: 1.5 }}>
        Choose from your existing conversations or start a new one
      </div>
    </div>
  );
}
